module.exports = {"320613001":"城东街道","320613002":"和平桥街道","320613003":"任港街道","320613004":"新城桥街道","320613005":"虹桥街道","320613006":"学田街道","320613007":"钟秀街道","320613008":"文峰街道","320613009":"观音山街道","320613010":"狼山镇街道","320613016":"永兴街道","320613017":"唐闸镇街道","320613018":"天生港镇街道","320613019":"秦灶街道","320613020":"陈桥街道","320613021":"幸福街道","320613401":"南通崇川经济开发区","320613402":"港闸开发区","320613403":"市北高新区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320613.json
// module id = 976
// module chunks = 0